<template>
    <svg width="12" height="12" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M4.30901 5.99875L8.28232 2.0278C8.57256 1.73774 8.57256 1.25762 8.28232 0.967552C7.99208 0.677483 7.51168 0.677483 7.22143 0.967552L2.71768 5.46862C2.42744 5.75869 2.42744 6.23881 2.71768 6.52888L7.22143 11.0299C7.37156 11.18 7.56172 11.25 7.75188 11.25C7.94203 11.25 8.13219 11.18 8.28232 11.0299C8.57256 10.7399 8.57256 10.2598 8.28232 9.9697L4.30901 5.99875Z"
        />
    </svg>
</template>
